module.exports = __webpack_public_path__ + "media/share_folder.37af53a2.mp4";